import { render, staticRenderFns } from "./SmartzPodPool.vue?vue&type=template&id=228545cc&scoped=true&"
import script from "./SmartzPodPool.vue?vue&type=script&lang=js&"
export * from "./SmartzPodPool.vue?vue&type=script&lang=js&"
import style0 from "./SmartzPodPool.vue?vue&type=style&index=0&id=228545cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228545cc",
  null
  
)

export default component.exports